import type { TProductType } from 'constants/dictionaries';

export const LABELS = {
  RegistrationAddress: 'Адрес регистрации',
  ChangePhoneNumber: 'Изменить номер',
  AdditionalPhoneLabel: 'Дополнительный телефон',
  PropertyAvailabilityLabel: 'Наличие имущества',
};

export const PRODUCT_CATEGORIES_LABELS = {
  CreditCard: 'Кредитная карта',
  Credit: 'Кредит',
  MicroCredit: 'Микрозаймы',
  AutoCredit: 'Автокредит',
  Mortgage: 'Ипотека',
};

export const REGION_LABEL_BY_PRODUCT_TYPE: Record<TProductType, string> = {
  CreditCard: 'В каком городе будете получать кредитную карту',
  Credit: 'В каком городе будете получать кредит',
  MicroCredit: 'В каком городе будете получать кредит',
};
